import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { publicMcpUrl } from './cb/experience'
import { apiOrigin } from './cb/api/http'
import { CONNECT_STEPS } from './connectSteps'

/**
 * How to connect Claude or ChatGPT to Rithmo, from anywhere in the customer dashboard: the one server address to copy and
 * the few steps in the assistant. The steps are the SHARED source of truth (connectSteps) so this and the admin Connections
 * page never diverge (connector-flow review item B). The assistant then opens Rithmo's connect page, where the person allows
 * it; that page names or creates their agent, so nothing needs to be set up here first.
 */
const ASSISTANTS = {
  claude: { label: 'Claude', steps: CONNECT_STEPS.claude },
  chatgpt: { label: 'ChatGPT', steps: CONNECT_STEPS.chatgpt },
}

export default function ConnectAssistantSteps() {
  const [which, setWhich] = useState('claude')
  const [copied, setCopied] = useState(false)
  const url = publicMcpUrl(apiOrigin())
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 2000) } catch { setCopied(false) }
  }
  return (
    <div className="rounded-xl border border-gray-300 bg-white p-4" data-connect-steps>
      <div className="flex gap-2" role="tablist">
        {Object.entries(ASSISTANTS).map(([key, a]) => (
          <button key={key} type="button" role="tab" aria-selected={which === key} onClick={() => setWhich(key)}
            className={`rounded-lg px-3 py-1.5 text-sm font-semibold ${which === key ? 'bg-primary-800 text-white' : 'text-gray-600 hover:bg-gray-100'}`}>
            {a.label}
          </button>
        ))}
      </div>
      <div className="mt-4 flex items-center gap-2">
        <code className="min-w-0 flex-1 truncate rounded-lg bg-gray-50 px-3 py-2 text-[13px] text-gray-800" data-mcp-url>{url}</code>
        <button type="button" onClick={copy} className="flex items-center gap-1.5 rounded-lg border border-gray-300 px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
          {copied ? <Check className="h-4 w-4 text-emerald-600" /> : <Copy className="h-4 w-4" />}
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <ol className="mt-4 list-decimal space-y-1.5 pl-5 text-sm text-gray-700">
        {ASSISTANTS[which].steps.map((s) => <li key={s}>{s}</li>)}
      </ol>
    </div>
  )
}
